import React from "react";
import s from "./SpareDetails.module.scss";
import { Tabs } from "antd";
import ImageGallery from "react-image-gallery";
import { ArrowUpOutlined, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import "react-image-gallery/styles/css/image-gallery.css";
import { useSelector } from "react-redux";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import SpareItem from "../../components/SpareItem/SpareItem";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import CarItem from "../../components/CarItem/CarItem";

const SpareDetails = () => {
  const { width } = useWindowDimensions();
  const spare = useSelector((state) => state.cars.spareDetails);

  return (
    <div>
      <div className={s.home}>
        {width > 800 ? <div className={s.left}>Реклама</div> : null}
        <div className={s.main}>
          <div className={s.top}>Реклама</div>
          <div className={s.body}>
            {width > 1200 ? <Header /> : <MobileHeader />}
            <section className={s.main_content}>
              <div className={s.content}>
                <div className={s.header}>
                  <div>
                    <div className={s.title}>{spare?.name}</div>
                    <div className={s.subtitle}>
                      {/* {spare?.location?.name} &nbsp; */}
                      <ArrowUpOutlined className={s.icon} /> Поднято {spare?.up}
                      &nbsp;&nbsp;&nbsp;
                      <PlusOutlined className={s.icon} />
                      &nbsp;Добавлено {spare?.created_at}&nbsp;&nbsp;&nbsp;
                      <EyeOutlined className={s.icon} />
                      &nbsp;{spare?.views}
                    </div>
                  </div>
                  <div className={s.price}>
                    <div className={s.price_usd}>$ {spare?.price}</div>
                    <div className={s.price_kgs}>{spare?.price * 89} сом</div>
                    <div className={s.other_prices}>
                      <div className={s.price_rub}>{spare?.price * 90}₽</div>
                      <div className={s.price_kzt}>{spare?.price * 444} ₸</div>
                    </div>
                  </div>
                </div>
                <div className={s.buttons}>
                  <button className={s.btn}>СРОЧНО</button>
                  <button className={s.btn}>
                    <ArrowUpOutlined /> &nbsp; UP
                  </button>
                  <button className={s.btn}>&nbsp; VIP</button>
                </div>
                <div className={s.tabs}>
                  <Tabs defaultActiveKey='1' type='spared'>
                    <TabPane tab='Объявление' key='1'>
                      <div className={s.tab1}>
                        <div className={s.car_info}>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Модель:</div>
                            <div className={s.item_value}>
                              {spare?.number} км
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Год выпуска:</div>
                            <div className={s.item_value}>
                              {spare?.manufacture_date}
                            </div>
                          </div>

                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Состояние:</div>
                            <div className={s.item_value}>
                              {spare?.condition === "new" ? "Новое" : "БУ"}
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Наличие:</div>
                            <div className={s.item_value}>
                              {spare?.availability === "order"
                                ? "На заказ"
                                : "В наличии"}
                            </div>
                          </div>
                          <div className={s.car_info_item}>
                            <div className={s.item_title}>
                              Для автомобилей:{" "}
                            </div>
                            <div className={s.item_value}>
                              {spare?.brand?.name} {spare?.model?.name}
                            </div>
                          </div>

                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Производитель:</div>
                            <div className={s.item_value}>
                              {spare?.manufacturer}
                            </div>
                          </div>

                          <div className={s.car_info_item}>
                            <div className={s.item_title}>Наличие</div>
                            <div className={s.item_value}>в наличии</div>
                          </div>
                        </div>
                        <div className={s.car_slider}>
                          <ImageGallery
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            items={spare?.images?.map((it) => ({
                              original: it?.image,
                              thumbnail: it?.image,
                            }))}
                          />
                        </div>
                      </div>
                      <div className={s.comments}>
                        <div className={s.comments_title}>
                          Комментарии продавца
                        </div>
                        <div
                          className={s.comments_text}
                          dangerouslySetInnerHTML={{
                            __html: spare?.seller_comment,
                          }}
                        ></div>
                      </div>
                    </TabPane>
                    <TabPane tab='Характеристики' key='2'>
                      <div>This is content for Tab 2</div>
                    </TabPane>
                    <TabPane tab='Статистика Цен' key='3'>
                      <div>This is content for Tab 3</div>
                    </TabPane>
                  </Tabs>
                </div>
                <div className={s.similar_cars}>
                  <div className={s.comments_title}>Похожие авто</div>
                  <div className={s.similar}>
                    {spare?.similar_spares?.map((it) => (
                      <div className={s.similar_item}>
                        <CarItem car={it} />
                      </div>
                    ))}
                  </div>
                </div>
                <div className={s.similar_cars}>
                  <div className={s.comments_title}>Запчасти</div>
                  <div className={s.similar}>
                    {spare?.similar_spares?.map((it) => (
                      <div className={s.similar_item}>
                        <CarItem car={it} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {width > 1200 ? (
                <div className={s.sidebar_add}>Реклама</div>
              ) : null}
            </section>
          </div>
        </div>
        {width > 800 ? <div className={s.right}>Реклама</div> : null}
      </div>
      <div className={s.footer}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};
// };

export default SpareDetails;
